import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { reloadToNewVersion } from "./lib/staleBuild";
import { installDecimalComma, installZeroSelect } from "./lib/zeroInput";

// Нуль у числовому полі не дописується до введеного (lib/zeroInput.ts).
installZeroSelect();
installDecimalComma();

// Частина старої збірки зникла після деплою — переходимо на нову
// (28.09.2026, див. lib/staleBuild.ts).
//
// БЕЗ `e.preventDefault()`: він глушить помилку, і лінивий екран отримує
// `undefined` замість модуля — «Cannot read properties of undefined (reading
// 'default')», білий екран (куплено 29.09.2026). Помилка мусить долетіти до
// межі помилок, яка сама покаже «оновлюю» або кнопку «Перезавантажити».
window.addEventListener("vite:preloadError", () => {
  void reloadToNewVersion();
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

// PWA: реєструємо service worker (public/sw.js) — саме він дає встановлення
// на телефон, швидкий старт і показ останньої сторінки без мережі.
//
// ТІЛЬКИ у проді. У dev він перехоплював би запити повз Vite і ламав
// hot-reload: правиш файл, а браузер віддає версію з кешу.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(`/sw.js?v=${__BUILD_ID__}`).catch((err) => {
      // Не критично: без нього сайт просто працює як звичайний сайт.
      console.warn("[pwa] service worker не зареєструвався:", err);
    });
  });
}
